let bindDataLinks = () => {
  $('[data-link]').click(event => {
    event.stopPropagation();

    window.location = $(event.currentTarget).data('link')
  });
}

$().ready(() => bindDataLinks());
